<template>
  <v-container>
    <v-card class="elevation-2 pa-4 mx-4">
      <v-card-title>{{ $t('Интеграция с DaData') }}</v-card-title>

      <v-form ref="form">
        <v-container>
          <v-row>
            <v-col cols="12">
              <Input
                v-model="url"
                label="URL интеграции"
                :rules="[].concat(validation.required())"
                required
              ></Input>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <Input
                v-model="token"
                label="API-ключ"
                :rules="[].concat(validation.required())"
                required
              ></Input>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <Input
                v-model="secret"
                label="Секретный ключ"
                :rules="[].concat(validation.required())"
                required
              ></Input>
            </v-col>
          </v-row>
        </v-container>
      </v-form>

      <v-card-actions class="justify-center">
        <v-btn
          @click="saveFeature"
          :disabled="isLoading"
          color="primary"
          variant="elevated"
          class="ml-auto"
        >{{ $t('Сохранить') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import api from "@/api";
import { toast } from '@/lib/toast';
import {useDaDataContragent} from "@/lib/composable";
import validation from "@/components/validation";
import Input from "@intec/vue-components/form/Input.vue";
import i18n from '@/plugins/i18n';

export default {
  setup() {
    const {loadDadataActive} = useDaDataContragent();
    return {loadDadataActive}
  },
  components: {
    Input
  },
  data() {
    return {
      url: null,
      token: null,
      secret: null,
      isLoading: false,
      validation
    };
  },
  methods: {
    async saveFeature() {
      if ((await this.$refs.form.validate()).valid) {
        let data = new FormData();
        data.append('url', this.url);
        data.append('token', this.token);
        data.append('secret', this.secret);
        data.append('test', true);

        const toastId = toast.loading('Загрузка данных...', {
          autoClose: false,
          closeOnClick: false,
          pauseOnFocusLoss: false,
          draggable: false,
          position: toast.POSITION.TOP_RIGHT
        });

        let resp;
        this.isLoading = true;
        try {
          resp = await api.post('/feature/lookupDaData', data);
        } catch (e) {
          resp = false;
        }
        this.isLoading = false;
        toast.update(toastId, {
          render: resp ? "Данные проверены и сохранены" : "Данные введены некорректно",
          type: resp ? "success" : 'error',
          isLoading: false,
          autoClose: 1000,
          closeOnClick: true,
          draggable: true
        });
      } else {
        toast.error('Заполните обязательные поля', {
          autoClose: 1000,
          closeOnClick: false,
          pauseOnFocusLoss: false,
          draggable: false,
          position: toast.POSITION.TOP_RIGHT
        });
      }
    }
  },
  async mounted() {
    const obj = await this.loadDadataActive();
    if (obj && obj.value) {
      this.url = obj.value.url;
      this.token = obj.value.token;
      this.secret = obj.value.secret;
    }
  }
};
</script>

<style scoped>
:deep(.v-field--variant-solo, .v-field--variant-solo-filled) {
  border-radius: 6px;
  border: 1px solid rgba(var(--blue-blue-secondary-hover));
  box-shadow: none;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

:deep(.v-field--variant-solo:hover, .v-field--variant-solo-filled:hover) {
  border-color: rgba(var(--grey-1));
}
</style>